export default "__VITE_ASSET__CLRZHvQt__"